<script>

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import EDL from './edl'
import axios from 'axios'

export default {
  page: {
    title: '360MDR EDLs - IPv4',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader,
    EDL
  },
  data () {
    return {
      updated: "",
      edls: [],
      title: 'IPv4 EDLs',
      category: 'List',
      items: [
        {
          text: 'Home',
          href: '/'
        },
        {
          text: 'IPv4 EDLs',
          active: true
        }
      ],
      appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev')
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      let that = this
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      const url = `${baseURL}/auto/edls`

      axios.get(url)
        .then((response) => {
          that.edls = response.data
          const now = new Date()
          that.updated = now.toLocaleString()
        })
        .catch(function () {

        })
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
    />
    <div
      class="container"
      style="max-width: 1420px !important;"
    >
      <div class="row page-title align-items-center" />
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- <span>
              Updated: {{ updated }}
            </span> -->
            <template v-for="(edlEntry, index) in edls">
              <div
                :key="index"
                class="row">
                <div class="col-12">
                  <EDL :data="edlEntry" />
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

